import { route } from '../helpers';
import { PromotionPages } from '../../constants/AppConstants';

export default route(PromotionPages.TOC_FAMILY_VERIFY, {
    getComponent(location, cb) {
        require.ensure(
            [],
            require => {
                cb(null, require('../../components/promotion/TOCFamilyVerify').default);
            },
            'promotion-toc-family-verify',
        );
    },
});
